import { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const pokosmsService = {
    getStatus,
    enable,
    disable,
    createDevice,
    refreshDeviceStatus,
    deleteDevice
};

/**
 * Get current PokoSMS integration status
 */
function getStatus() {
    return axios.get('/api/services/app/PokoSms/GetStatus', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}

/**
 * Enable PokoSMS integration (creates System API Key)
 */
function enable() {
    return axios.post('/api/services/app/PokoSms/Enable', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}

/**
 * Disable PokoSMS integration (deletes API key, device, and all SMS)
 */
function disable() {
    return axios.post('/api/services/app/PokoSms/Disable', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}

/**
 * Create new device for pairing (generates QR code)
 */
function createDevice() {
    return axios.post('/api/services/app/PokoSms/CreateDevice', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}

/**
 * Refresh device status from SMS Gateway
 */
function refreshDeviceStatus() {
    return axios.post('/api/services/app/PokoSms/RefreshDeviceStatus', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}

/**
 * Delete current device (unpair)
 */
function deleteDevice() {
    return axios.post('/api/services/app/PokoSms/DeleteDevice', {}, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    });
}
